import * as React from 'react';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { useEndedEventIds, useJoinableEventIds } from '../../api/event';
import { useCurrentUser } from '../../redux/selectors/authSelectors';
import PlayerImg from '../../static/svg/MyPage_Player.svg';
import EventTable from '../eventProvider/EventTable';
import CommonBG from '../uiElements/CommonBG';

interface EventsProps {}
const Events: React.FC<EventsProps> = () => {
  const user = useCurrentUser();
  const history = useHistory();

  const onJoin = (eventId?: string) => {
    history.push(`/events/${eventId}`);
  };

  const [eventIds, loading] = useJoinableEventIds(user);
  const [endedIds, loading2] = useEndedEventIds(user);

  const availableIds = React.useMemo(() => {
    if (!endedIds) {
      return eventIds;
    }
    return eventIds?.filter(e => !endedIds.includes(e)) ?? [];
  }, [eventIds, endedIds]);

  return (
    <CommonBG withHeader withFooter headerOptions={{ buttonType: 'logout' }}>
      <EventsWrapper>
        <Content>
          <Player>
            <SVG src={PlayerImg} />
            <p>{user?.displayName ?? 'NoName'}</p>
          </Player>

          <EventTable
            eventIds={availableIds ?? []}
            type='eventsView'
            onJoin={onJoin}
          />
          {(loading || loading2) && <Loading>Loading...</Loading>}
        </Content>
      </EventsWrapper>
    </CommonBG>
  );
};

const EventsWrapper = styled.div``;

const Content = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 2.4rem 8rem 0;
`;

const Player = styled.div`
  display: flex;
  align-items: center;
  height: 7rem;
  line-height: 7rem;
  font-size: 2.8rem;
  margin: 0 auto;

  p {
    font-weight: bold;
  }

  svg {
    width: 4rem;
    height: 4rem;
    margin-right: 4rem;
  }
`;

const Loading = styled.div`
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  padding: 1rem 0;
`;

export default Events;
